import { ThemeProvider as NextThemesProvider } from 'next-themes';
import type { ReactNode } from 'react';

interface AppThemeProviderProps {
  children: ReactNode;
}

/** Dark mode default per STUDY-015 layout constraint. */
export function AppThemeProvider({ children }: AppThemeProviderProps): React.JSX.Element {
  return (
    <NextThemesProvider attribute="class" defaultTheme="dark" enableSystem={false} forcedTheme="dark">
      {children}
    </NextThemesProvider>
  );
}
